import { callApi } from '../common/services/baseServices';
import { host } from '../environment';
import { getCookie } from '../common/enum';
// import { dataDummy } from './data';

const ACTIONS = {
    GET_DATA_NEWS_SUCCESS: 'GET_DATA_NEWS_SUCCESS',
    GET_DATA_NEWS_ERROR: 'GET_DATA_NEWS_ERROR',
    READ_DATA_NEWS_SUCCESS: 'READ_DATA_NEWS_SUCCESS',
    READ_DATA_NEWS_ERROR: 'READ_DATA_NEWS_ERROR',
    // ADD_NEWS_SUCCESS: 'ADD_NEWS_SUCCESS',
    // ADD_NEWS_ERROR: 'ADD_NEWS_ERROR',
    // DELETE_NEWS_SUCCESS: 'DELETE_NEWS_SUCCESS',
    // DELETE_NEWS_ERROR: 'DELETE_NEWS_ERROR',
    // GET_COMPANY_SUCCESS: 'GET_COMPANY_SUCCESS',
    // GET_COMPANY_ERROR: 'GET_COMPANY_ERROR',
    // GET_DETAIL_NEWS_SUCCESS: 'GET_DETAIL_NEWS_SUCCESS',
    // GET_DETAIL_NEWS_ERROR: 'GET_DETAIL_NEWS_ERROR',
    // UPDATE_NEWS_SUCCESS: 'UPDATE_NEWS_SUCCESS',
    // UPDATE_NEWS_ERROR: 'UPDATE_NEWS_ERROR'
};


const updateStatus = (type, data) => ({
    type,
    data,
});



const getNews = (data) => {
    const config = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
    };

    let url = `${host.serverTest}api/notices?keyword=${data.keyword}&page=${data.page}`;

    return (dispatch) => {
        callApi(url,
            config,
            (data) => {
                // console.log(data);
                dispatch(updateStatus(ACTIONS.GET_DATA_NEWS_SUCCESS, data));
            },
            (err) => {
                dispatch(updateStatus(ACTIONS.GET_DATA_NEWS_ERROR, err));
            });
    };
}

const readNews = (notice_id) => {
    const config = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
    };

    let url = `${host.serverTest}api/notices/${notice_id}/read`;

    return (dispatch) => {
        callApi(url,
            config,
            (data) => {
                // console.log(data);
                dispatch(updateStatus(ACTIONS.READ_DATA_NEWS_SUCCESS, data));
            },
            (err) => {
                dispatch(updateStatus(ACTIONS.READ_DATA_NEWS_ERROR, err));
            });
    };
}



export { ACTIONS, getNews, readNews };
